import { type WebObservability, WebObservabilityService } from "observability";

const useWebObservability = (): WebObservability | null => {
  const webObservabilityService = WebObservabilityService.getInstance();
  return webObservabilityService.apm;
};

export default useWebObservability;
